import { UserRequest } from "../models/UserRequest.js";
import { UserResponse } from "../models/UserResponse.js";

const API_ENDPOINT = "https://script.google.com/macros/s/AKfycbwyIJ6DXJmeiTmHifEwWgngXt17iVELMS2CTWLH_0tqUASECXUZapLsaw7lXDnulEUo6Q/exec";

export const quotaStatus = async (userRequest) => {
    try {
        const formData = new URLSearchParams();
        formData.append("email", userRequest.email);
        formData.append("apiKey", userRequest.apiKey);

        const response = await fetch(API_ENDPOINT, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: formData,
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        return new UserResponse(true, "Request successful", data);
    } catch (error) {
        console.error("Error checking account quota status:", error);
        return new UserResponse(false, error.message);
    }
};
